import React, { useState, useEffect, useRef } from 'react'
import { Dialog as Modal, Button } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import axios from 'axios'
import logger from './logger'

const warningSvg = 'https://www.paypalobjects.com/shopping/icons/warning.svg'
const SECOND_IN_MILLISECONDS = 1000
const MINUTE_IN_MILLISECONDS = SECOND_IN_MILLISECONDS * 60
const OPEN_MODAL_INTERVAL_IN_MINUTES = 12
const RELOAD_PAGE_INTERVAL_IN_MINUTES = 15

const LogoutModal = () => {
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false)
  const openModalTime = useRef(new Date())
  const reloadPageTime = useRef(new Date())

  const resetTime = (dateObject: Date, minutesToAdd: number) => {
    let newTime = new Date()
    newTime = new Date(
      newTime.getTime() + minutesToAdd * MINUTE_IN_MILLISECONDS
    )
    dateObject.setTime(newTime.getTime())
  }

  useEffect(() => {
    resetTime(openModalTime.current, OPEN_MODAL_INTERVAL_IN_MINUTES)
    resetTime(reloadPageTime.current, RELOAD_PAGE_INTERVAL_IN_MINUTES)
    const reloadPageInterval = setInterval(() => {
      if (new Date() >= reloadPageTime.current) {
        location.reload()
        clearInterval(reloadPageInterval)
      }
    }, SECOND_IN_MILLISECONDS)

    const openModalInterval = setInterval(() => {
      if (new Date() >= openModalTime.current) {
        setIsLogoutModalOpen(true)
      }
    }, SECOND_IN_MILLISECONDS)

    return () => {
      clearInterval(reloadPageInterval)
      clearInterval(openModalInterval)
    }
  }, [])

  useEffect(() => {
    if (!isLogoutModalOpen) {
      resetTime(openModalTime.current, OPEN_MODAL_INTERVAL_IN_MINUTES)
      resetTime(reloadPageTime.current, RELOAD_PAGE_INTERVAL_IN_MINUTES)
    }
  }, [isLogoutModalOpen])

  const onCloseModal = () => {
    setIsLogoutModalOpen(false)
    // making a call to /offers/refresh-session makes it so we go through the
    // auth middleware which refreshes the session
    axios('/offers/refresh-session').catch((err: Error) => {
      logger.error('Error refreshing session', err)
    })
  }

  return (
    <Modal
      title=""
      isOpen={isLogoutModalOpen}
      closeOnBackgroundClick={true}
      onCloseComplete={onCloseModal}
    >
      <div style={{ textAlign: 'center' }}>
        <img src={warningSvg} alt="" />
        <h1>
          <Message id="main.holidaydeals.logoutModal.title" />
        </h1>
        <p>
          <Message id="main.holidaydeals.logoutModal.description" />
        </p>
        <Button onClick={onCloseModal} style={{ margin: '40px 0' }}>
          <Message id="main.holidaydeals.logoutModal.button" />
        </Button>
      </div>
    </Modal>
  )
}

export default LogoutModal
